import { gql } from '@apollo/client';

export * from './protectionBeneficiaries.query.generated';

export const PROTECTION_BENEFICIARIES = gql`
  query protectionBeneficiaries($appId: ID!) {
    appProtections(appId: $appId) {
      id
      ... on ContinuityEscrow {
        beneficiary {
          id
        }
      }
      ... on SaasEscrow {
        beneficiary {
          id
        }
      }
      ... on SoftwareEscrow {
        beneficiary {
          id
        }
      }
    }
  }
`;
